import React from 'react';
import { Instagram, Youtube, Linkedin } from 'lucide-react';
import { BsTwitterX } from 'react-icons/bs';
import { motion, Variants } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
const socials = [
  {
    Icon: Instagram,
    link: 'https://instagram.com/thedecentden',
  },
  {
    Icon: BsTwitterX,
    link: 'https://x.com/TheDecentDen',
  },
  {
    Icon: Youtube,
    link: 'https://youtube.com/@thedecentden?si=KJ88P2UHJUFslm7W',
  },
  {
    Icon: Linkedin,
    link: 'https://linkedin.com/company/decentden',
  },
];

const container = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.2,
    },
  },
};

const fadeLeft: Variants = {
  hidden: { opacity: 0, x: -60 },
  show: {
    opacity: 1,
    x: 0,
    transition: { duration: 1, ease: 'easeOut' },
  },
};

const fadeRight: Variants = {
  hidden: { opacity: 0, x: 60 },
  show: {
    opacity: 1,
    x: 0,
    transition: { duration: 1, ease: 'easeOut' },
  },
};

const fadeUp: Variants = {
  hidden: { opacity: 0, y: 30 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 1, ease: 'easeOut' },
  },
};

const iconHover: Variants = {
  hover: {
    scale: 1.2,
    rotate: 6,
    transition: { type: 'spring', stiffness: 300 },
  },
};

const Footer: React.FC = () => {
  const navigate = useNavigate();
  return (
    <motion.footer
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: false }}
      transition={{ duration: 1 }}
      style={{
        borderImageSource: 'linear-gradient(90deg, #000001 0%, #FFFFFF 50%, #000001 100%)',
        borderImageSlice: 1,
        borderTopWidth: '2px',
      }}
      className="bg-black text-white border-t border-white/10 z-50 relative pb-14"
    >
      <motion.div
        variants={container}
        initial="hidden"
        whileInView="show"
        viewport={{ once: false }}
        className="mx-auto px-6 md:px-10 lg:px-16 pt-16"
      >
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 items-center">
          <motion.div
            variants={fadeLeft}
            className="flex flex-col items-center md:items-start gap-4"
          >
            <motion.img
              src="/images/logo.svg"
              alt="Decent Den"
              className="w-32"
              whileHover={{ scale: 1.05 }}
            />
            <motion.p
              whileHover={{ scale: 1.05 }}
              className="text-2xl font-irish items-center justify-center"
            >
              Decent Den
            </motion.p>
          </motion.div>

          <motion.div variants={fadeUp} className="flex flex-col items-center gap-6">
            <h4 className="font-irish tracking-wide text-lg">Follow Us</h4>

            <div className="flex gap-6">
              {socials.map(({ Icon, link }, i) => (
                <motion.a
                  key={i}
                  href={link}
                  target="_blank"
                  rel="noopener noreferrer"
                  variants={iconHover}
                  whileHover="hover"
                  className="hover:text-primary transition"
                >
                  <Icon size={22} />
                </motion.a>
              ))}
            </div>

            <h4 className="font-inika tracking-wide text-[14px] text-center">
              Copyright © 2026 CodeMongoose Technologies Pvt. Ltd.{' '}
            </h4>
            <div className="flex justify-between w-full">
              <h4
                onClick={() => navigate('/privacy-policy')}
                className="font-inika cursor-pointer tracking-wide text-[14px] text-center"
              >
                Privacy Policy
              </h4>
              <h4
                onClick={() => navigate('/terms-conditions')}
                className="font-inika cursor-pointer tracking-wide text-[14px] text-center"
              >
                Terms & Conditions
              </h4>
            </div>
          </motion.div>

          <motion.div
            variants={fadeRight}
            className="flex flex-col items-center md:items-end gap-2"
          >
            <span className="text-sm text-[#AAB1B9]">Technology Partner</span>

            <motion.a
              href="https://codesfortomorrow.com/"
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{ scale: 1.05 }}
              className="flex items-center gap-3 hover:opacity-80 transition"
            >
              <img
                src="/images/logos/logo_cft.svg"
                className="invert brightness-0"
                alt="CODES FOR TOMORROW"
              />
              {/* <img src='/images/logos/logo_cft.svg' className='' alt='CODES FOR TOMORROW'/> */}
              {/* <p className="tracking-widest">CODES FOR TOMORROW</p> */}
            </motion.a>
          </motion.div>
        </div>
      </motion.div>
    </motion.footer>
  );
};

export default Footer;
